import { Typography as e } from "../../../Typography/Typography.mjs";
import { Button as t } from "../../Button/Button.mjs";
import { useMobile as n } from "../../../hooks/useMobile.mjs";
import { Popup as r } from "../../Popup/Popup.mjs";
import { CalendarMonth as i } from "./CalendarMonth.mjs";
import { Divider as a, DualPopup as ee, LoadMoreBtn as te, MobileCalendarContent as ne, PopupCalendarsRow as o, PopupFooter as s } from "../styled/Popups.styled.mjs";
import { useCalendarNavigation as c } from "../hooks/useCalendarNavigation.mjs";
import { ClearBtn as re, Placeholder as ie, Root as ae, Trigger as oe, TriggerInner as se } from "../styled/DatePicker.styled.mjs";
import { useOutsideClose as ce } from "../../../hooks/useOutsideClose.mjs";
import { useBlockedBounds as le } from "../hooks/useBlockedBounds.mjs";
import { useRangeSelection as ue } from "../hooks/useRangeSelection.mjs";
import { useDraftRange as de } from "../hooks/useDraftRange.mjs";
import fe, { useRef as pe, useState as l } from "react";
import { useTranslation as u } from "@maat/store-i18n";
import { Fragment as me, jsx as d, jsxs as f } from "react/jsx-runtime";
import { CalendarDays as he, X as ge } from "lucide-react";
import { formatDatePicker as p } from "@maat/datetime";
//#region src/components/DatePicker/components/DateRangePicker.tsx
var m = ({ value: m, onChange: h, placeholder: _e, disabled: g, minDate: _, maxDate: v, label: y, error: b, className: ve, annotations: x, blockedRanges: S, placement: ye = "bottom", months: C = 2, lockStart: w = !1, minNights: be, maxNights: xe, disabledStartDates: T, disabledEndDates: E }) => {
	let { t: D } = u("ds"), { isMobile: O } = n(), [k, A] = l(!1), j = _e ?? D("ds:datePicker.selectDateRange"), [M, N] = l(null), [Se, Ce] = l(3), P = pe(null), { view: F, navigate: I, nextMonth: we, nextYear: Te, offsetMonth: Ee } = c(), { draftStart: L, draftEnd: R, setDraftStart: z, setDraftEnd: B, reset: De } = de(m), [V, H] = l(w && m?.start ? "end" : "start"), { effectiveMin: Oe, effectiveMax: ke, impossibleRange: U, nextBlockedFrom: Ae } = le(V, L, S, _, v, be, xe), { handleDayClick: W } = ue({
		start: L,
		end: R,
		lockStart: w,
		onSelect: (e) => {
			z(e.start), B(e.end);
		},
		impossibleRange: U,
		nextBlockedFrom: Ae,
		picking: V,
		setPicking: H
	});
	ce(P, {
		enabled: !O,
		onClose: () => A(!1)
	});
	let G = m?.start ?? null, K = m?.end ?? null, q = () => {
		De(), H(w && m?.start ? "end" : "start"), A(!0);
	}, je = () => {
		h?.({
			start: L,
			end: R
		}), A(!1);
	}, J = () => {
		w ? (B(null), H("end"), h?.({
			start: m?.start ?? null,
			end: null
		})) : (z(null), B(null), H("start"), h?.({
			start: null,
			end: null
		}));
	}, Y = U ? _ : Oe, X = U ? v : ke, Z = U || V === "start" ? T : E, Q = () => G && K ? `${p(G)} → ${p(K)}` : G ? `${p(G)} → ...` : null, $ = /* @__PURE__ */ f(s, { children: [/* @__PURE__ */ d(t, {
		variant: "outline",
		size: "sm",
		type: "button",
		onClick: J,
		children: D("ds:datePicker.clearDates")
	}), /* @__PURE__ */ d(t, {
		variant: "primary",
		size: "sm",
		type: "button",
		onClick: je,
		disabled: !L,
		children: D("common:actions.save")
	})] }), Me = /* @__PURE__ */ f(ne, { children: [Array.from({ length: Se }, (e, t) => {
		let { year: n, month: r } = Ee(t);
		return /* @__PURE__ */ d(fe.Fragment, { children: /* @__PURE__ */ d(i, {
			year: n,
			month: r,
			onPrev: () => {},
			onNext: () => {},
			rangeStart: L,
			rangeEnd: R,
			hoverDate: V === "end" ? M : null,
			onDayClick: W,
			onDayHover: N,
			minDate: Y,
			maxDate: X,
			annotations: x,
			blockedRanges: S,
			disabledDates: Z,
			hidePrev: !0,
			hideNext: !0,
			fluid: !0
		}) }, `${n}-${r}`);
	}), /* @__PURE__ */ d(te, {
		type: "button",
		onClick: () => Ce((e) => e + 3),
		children: /* @__PURE__ */ d(e, {
			variant: "small",
			color: "secondary",
			inline: !0,
			children: "Load more dates"
		})
	})] });
	return /* @__PURE__ */ f(ae, {
		ref: P,
		className: ve,
		children: [
			y && /* @__PURE__ */ d(e, {
				variant: "label",
				children: y
			}),
			/* @__PURE__ */ f(oe, {
				type: "button",
				$open: k,
				$error: !!b,
				$disabled: g,
				disabled: g,
				onClick: k ? () => A(!1) : q,
				"aria-haspopup": "dialog",
				"aria-expanded": k,
				children: [/* @__PURE__ */ f(se, { children: [/* @__PURE__ */ d(he, {
					size: 15,
					opacity: .6
				}), Q() ? /* @__PURE__ */ d("span", { children: Q() }) : /* @__PURE__ */ d(ie, { children: j })] }), (G || K) && /* @__PURE__ */ d(re, {
					type: "button",
					onClick: (e) => {
						e.stopPropagation(), J();
					},
					"aria-label": D("common:actions.clear"),
					children: /* @__PURE__ */ d(ge, { size: 13 })
				})]
			}),
			O ? /* @__PURE__ */ d(r, {
				open: k,
				onClose: () => A(!1),
				title: y ?? D("ds:datePicker.selectDateRange"),
				footer: $,
				children: Me
			}) : k && /* @__PURE__ */ f(ee, {
				role: "dialog",
				"aria-label": D("ds:datePicker.rangeDialogLabel"),
				$placement: ye,
				children: [/* @__PURE__ */ f(o, { children: [/* @__PURE__ */ d(i, {
					year: F.year,
					month: F.month,
					onPrev: () => I(-1),
					onNext: () => I(1),
					rangeStart: L,
					rangeEnd: R,
					hoverDate: V === "end" ? M : null,
					onDayClick: W,
					onDayHover: N,
					minDate: Y,
					maxDate: X,
					annotations: x,
					blockedRanges: S,
					disabledDates: Z,
					hideNext: C === 2
				}), C === 2 && /* @__PURE__ */ f(me, { children: [/* @__PURE__ */ d(a, {}), /* @__PURE__ */ d(i, {
					year: Te,
					month: we,
					onPrev: () => I(-1),
					onNext: () => I(1),
					rangeStart: L,
					rangeEnd: R,
					hoverDate: V === "end" ? M : null,
					onDayClick: W,
					onDayHover: N,
					minDate: Y,
					maxDate: X,
					annotations: x,
					blockedRanges: S,
					disabledDates: Z,
					hidePrev: !0
				})] })] }), $]
			}),
			b && /* @__PURE__ */ d(e, {
				variant: "caption",
				color: "error",
				children: b
			})
		]
	});
};
//#endregion
export { m as DateRangePicker };
